<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-1">
    <div class="flex flex-col gap-3 rounded-xl border bg-gray-50 p-4">
      <div>
        <p class="font-semibold text-[#2e234b]">
          {{ $t("ticketPurchase.auth.continueAsGuest") }}
        </p>
        <p class="text-sm text-gray-600">
          {{ $t("ticketPurchase.auth.guestDescription") }}
        </p>
      </div>
      <button
        class="rounded-lg bg-[#2e234b] px-4 py-2 text-white hover:bg-[#251b3d]"
        @click="$emit('guest')"
      >
        {{ $t("ticketPurchase.auth.continueAsGuest") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits<{
  (e: "guest"): void;
}>();
</script>
